import update from 'react/lib/update';
import ResourceListItem from '../components/resource-list-item';

import {
	SET_TOTAL_PAGES,
	REQUEST_POSTS,
	RECEIVE_POSTS,
	SET_ITEM_VIEW,
	SET_STATIC_HTML
} from '../actions/posts';

const initialState = {
	totalPages: 1,
	isLoading: false,
	hasLoaded: false,
	items: [],
	itemView: ResourceListItem,
	staticHtml: ''
}

function posts(state = initialState, action){
	switch(action.type){
		case SET_TOTAL_PAGES:
			return update(state, {
				totalPages: { $set: action.totalPages }
			});

		case REQUEST_POSTS:
			return update(state, {
				isLoading: { $set: true },
				items: { $set: [] }
			});

		case RECEIVE_POSTS:
			return update(state, {
				isLoading: { $set: false },
				hasLoaded: { $set: true },
				items: { $set: [...state.items, ...action.items] }
			});

		case SET_ITEM_VIEW:
			return update(state, { itemView: { $set: action.itemView } })

		case SET_STATIC_HTML:
			return update(state, { staticHtml: {$set: action.html } })

		default:
			return state
	}
}

export default posts;



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/blog-grid/reducers/posts.js